import * as React from "react";
import { Form, Params, redirect, useActionData, useLoaderData, useNavigate, } from "react-router-dom";
import { Button, Input, Message } from "semantic-ui-react";
import "./contact-edit.css";
import { RootStore } from "../../../stores/root-store";
import { Contact } from "../../../stores/contact/contact-store";
import { TransportError } from "../../../stores/data-transporter";
import LabeledInput from "../../../components/labeled-input/labeled-input";

export async function action(request: Request, rootStore: RootStore) {
    try {
        const formData = await request.formData();
        const formDataObject: any = Object.fromEntries(
            Array.from(formData).filter(([_, v]) => v != null && v !== "")
        );
        const rootStoreSession = rootStore.session;
        const contact = await rootStoreSession.contactStore.update(formDataObject);
        return redirect(`/kontakte/${contact.id}`);
    } catch (e: Error) {
        if (e instanceof TransportError) {
            switch (e.statusCode) {
                case 400:
                    return "Es sind nicht alle erforderlichen Felder ausgefüllt.";
                default:
                    return "Es ist ein unerwarteter Fehler aufgetreten!";
            }
        } else {
            return e.message;
        }
    }
}

export async function loader(params: Params, rootStore: RootStore) {
    if (params.contactId !== undefined) {
        const contactId = parseInt(params.contactId) || 0;
        const rootStoreSession = rootStore.newSession();
        return await rootStoreSession.contactStore.load(contactId);
    }

    throw new Response("", {
        status: 404,
        statusText: "Kontakt wurde nicht gefunden",
    });
}

export default function ContactEdit(): JSX.Element {
    const contact = useLoaderData() as Contact;
    const navigate = useNavigate();
    const errorMsg = useActionData();

    return (
        <div className="contactEdit">
            <h1>Kontakt {`'${contact.firstName} ${contact.lastName}'`} bearbeiten</h1>
            {errorMsg !== undefined && (
                <Message error={true} compact={true}>
                    {errorMsg}
                </Message>
            )}
            <Form method="post" autoComplete="off">
                <LabeledInput
                    label="Körperschaft"
                    inputElement={
                        <Input
                            type="text"
                            name="body"
                            defaultValue={contact.body}
                        />
                    }
                />
                <LabeledInput
                    label="Vorname"
                    required={true}
                    inputElement={
                        <Input
                            placeholder="Vorname"
                            type="text"
                            name="firstName"
                            defaultValue={contact.firstName}
                        />
                    }
                />
                <LabeledInput
                    label="Nachname"
                    required={true}
                    inputElement={
                        <Input
                            type="text"
                            name="lastName"
                            defaultValue={contact.lastName}
                        />
                    }
                />
                <LabeledInput
                    label="Strasse"
                    inputElement={
                        <Input
                            type="text"
                            name="street"
                            defaultValue={contact.street}
                        />
                    }
                />
                <LabeledInput
                    label="Nummer"
                    inputElement={
                        <Input
                            type="text"
                            name="streetNr"
                            defaultValue={contact.streetNr}
                        />
                    }
                />
                <LabeledInput
                    label="Adresszusatz"
                    inputElement={
                        <Input
                            type="text"
                            name="additionalAddressLine"
                            defaultValue={contact.additionalAddressLine}
                        />
                    }
                />
                <LabeledInput
                    label="PLZ"
                    inputElement={
                        <Input
                            type="text"
                            name="zipCode"
                            defaultValue={contact.zipCode}
                        />
                    }
                />
                <LabeledInput
                    label="Ort"
                    inputElement={
                        <Input
                            type="text"
                            name="city"
                            defaultValue={contact.city}
                        />
                    }
                />
                <LabeledInput
                    label="E-Mail"
                    inputElement={
                        <Input
                            type="text"
                            name="email"
                            defaultValue={contact.email}
                        />
                    }
                />
                <LabeledInput
                    label="Telefon"
                    inputElement={
                        <Input
                            type="text"
                            name="phone"
                            defaultValue={contact.phone}
                        />
                    }
                />
                <input type="hidden" name="id" value={contact.id}/>
                <div className="buttons">
                    <Button
                        type="button"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        Abbrechen
                    </Button>
                    <Button type="submit">Speichern</Button>
                </div>
            </Form>
        </div>
    );
}
